var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ProductService, KompisDefaultFields, } from "@inter-ikea-kompis/services";
import { ProductOptionalFieldNameEnum } from "@inter-ikea-kompis/enums";
import { getDexfSettingsService } from "./serviceSettings";
import { getDexfApiKey } from "./utils/dexf";
import { getLocalization } from "./utils/helpers";
export var Segment;
(function (Segment) {
    Segment["development"] = "development";
    Segment["test"] = "test";
    Segment["verification"] = "verification";
    Segment["production"] = "production";
})(Segment || (Segment = {}));
const getDevelopmentSegmentParams = () => {
    return {
        segment: "development",
    };
};
const getProductionSegmentParams = () => {
    return {
        segment: "production",
    };
};
const getFields = () => [
    ...KompisDefaultFields,
    ProductOptionalFieldNameEnum.asset,
    "genericProduct",
];
const getOptionalParams = (segment) => {
    const optionalParams = segment === Segment.production
        ? getProductionSegmentParams()
        : getDevelopmentSegmentParams();
    return {
        customParams: Object.assign({}, optionalParams),
    };
};
export const fetchProductData = (appId, segment) => __awaiter(void 0, void 0, void 0, function* () {
    const settings = yield getDexfSettingsService(appId, segment);
    const productService = new ProductService({
        locale: getLocalization(),
        settings,
        dexfApiKey: getDexfApiKey(appId, segment === Segment.production),
        dexfApplicationId: appId,
    });
    const products = yield productService.getApplicationProducts(getFields(), getOptionalParams(segment));
    //If we want to remove SPRs later, just add this again.
    /* const removeSPRs = (products: IProduct[]) =>
      products.filter((product) => product.content?.itemType !== "SPR"); */
    return products;
});
